// @mui
import { styled } from '@mui/material/styles';
import { Avatar, Box, Typography } from '@mui/material';
// utils
import imageLoader from '@/utils/imageLoader';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  marginBottom: theme.spacing(3),
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 320,
  padding: theme.spacing(1.5),
  marginTop: theme.spacing(0.5),
  borderRadius: theme.shape.borderRadius,
  backgroundColor: theme.palette.background.neutral,
}));

const InfoStyle = styled(Typography)(({ theme }) => ({
  display: 'flex',
  marginBottom: theme.spacing(0.75),
  color: theme.palette.text.secondary,
}));

// ----------------------------------------------------------------------

export default function CommentItem({ comment }) {
  const { comment: commentContent, user } = comment;
  const {
    detail: { firstName, lastName, profilePhoto },
  } = user;
  return (
    <RootStyle>
      <Box
        sx={{
          display: 'flex',
        }}
      >
        <Avatar
          alt={firstName + ' ' + lastName}
          src={imageLoader({ src: profilePhoto ? profilePhoto : '' })}
          sx={{ width: 32, height: 32 }}
        />

        <Box sx={{ ml: 2 }}>
          <InfoStyle noWrap variant="caption">
            {firstName} {lastName}
          </InfoStyle>

          <ContentStyle>
            <Typography variant="body2">{commentContent}</Typography>
          </ContentStyle>
        </Box>
      </Box>
    </RootStyle>
  );
}
